import React, { useState, useEffect } from "react";
import styled from 'styled-components';
import {renderRatingStars} from '../../utils/utilsHelpers';

export default function FiltersTags(props) {

    useEffect(() => {

    });

    const renderChip = (filter, chip) => {
        if(filter == 'rating') {
            return renderRatingStars(chip)
        } else if (filter == 'sentiment') {
            return `${chip} sentiment score`
        } else return chip;
    }


    return (
        <StyledChipsContainer className={`d-flex ${props.classes}`}>
            {
                Object.keys(props.selectedFilters).map((filterType) => { 
                    return(
                        Object.keys(props.selectedFilters[filterType]).map((filterKey, index) => {
                            return (
                                props.selectedFilters[filterType][filterKey].map((chip, index) => {
                                    return (
                                        <button className={'btn btn-outline-secondary btn-sm btn-rounded d-flex align-items-center'} key={index} onClick={() => props.onChipRemove(filterKey, chip)}>
                                            <span>{renderChip(filterKey, chip)}</span>
                                            <i className="fas fa-times ms-1"></i>
                                        </button>
                                    )
                                })
                            )
                        })
                    )
                })
            }
        </StyledChipsContainer>
    )
}

const StyledChipsContainer = styled.div`
    &>button:not(:last-child) {
        margin-right: 10px;
    }
`;
